import { EventSourcePolyfill, EventSourcePolyfillInit } from 'event-source-polyfill';

interface SSEOptions extends EventSourcePolyfillInit {
  baseUrl: string;
}

export const createSSEConnection = (path: string, { baseUrl, ...eventSourceInitOptions }: SSEOptions) => {
  const url = `${baseUrl}${path}`;
  const es = new EventSourcePolyfill(url, eventSourceInitOptions) as EventSource;

  // 종료 함수 함께 리턴
  const close = () => {
    es.close();
  };

  return { close, eventSource: es };
};
